import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
  JOBS_FETCH,
  JOB_FETCH,
  JOBS_ORDERBY,
  JOBS_FILTER,
  JOBS_PAGINATION,
} from "../constants";

const initialState = {
  job: null,
  jobs: [],
  jobsCount: null,
  jobsOrderBy: "createdAt",
  jobsFilter: null,
  jobsPagination: {
    defaultActivePage: 1,
    totalPages: 1,
    activePage: 1,
  },
};

const persistConfig = {
  key: "jobs",
  storage,
  blacklist: ["jobsFilter", "jobsPagination"],
};

function jobsReducer(state = initialState, action) {
  switch (action.type) {
    case JOBS_FETCH:
      return { ...state, jobs: action.result, jobsCount: action.count };

    case JOB_FETCH:
      return { ...state, job: action.result };

    case JOBS_ORDERBY:
      return { ...state, jobsOrderBy: action.value };

    case JOBS_FILTER:
      return { ...state, jobsFilter: action.value };

    case JOBS_PAGINATION:
      return { ...state, jobsPagination: action.value };

    default:
      return state;
  }
}


export default persistReducer(persistConfig, jobsReducer);